import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Buscando entre papeles sueltos qué trabajaste en la sesión anterior', 'Preguntándole al paciente cómo se sentía porque no tenés registro de la vez pasada', 'Sin evidencia de la evolución de tus tratamientos para mostrarle al paciente su progreso', 'Siempre las mismas fichas improvisadas porque no tenés un sistema clínico serio', 'Sin documentación profesional que respalde tu trabajo y te proteja ante cualquier situación', 'El gabinete sin insumos en plena jornada porque nunca controlás el stock', 'Pacientes que no vuelven porque no perciben el valor profesional de tu trabajo', 'Cada semana empezás el mismo ciclo de caos, una y otra vez'];
  return <Section className="max-w-4xl" data-id="element-226">
      <div className="text-center mb-12" data-id="element-227">
        <h2 className="md:text-5xl font-serif font-bold mb-6 text-[22px]" data-id="element-228">
          El desorden en el gabinete tiene un costo que quizás no estás viendo
        </h2>
        <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-229">
          Cuando no llevás un registro claro de cada sesión, no es solo un
          problema de organización. Es que tus pacientes sienten que no hay un
          plan. Sienten que cada sesión es independiente. Sienten que están
          pagando por algo que no avanza. Y cuando eso pasa… Se van. No porque
          no seas buena terapeuta. Sino porque la experiencia de tratamiento no
          les transmite continuidad ni profesionalismo. La diferencia entre una
          terapeuta que fideliza y una que no muchas veces no está en su
          técnica. Está en cómo documenta, registra y hace seguimiento de sus
          pacientes.
        </p>

        <p className="text-xl font-medium text-brand-rose mt-6" data-id="element-230">
          No es falta de vocación. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12 pt-[3px] pb-[3px] space-y-[14px] bg-white/60 border-brand-pink/30" data-id="element-231">
        <h3 className="font-medium mb-6 flex items-center text-brand-text/90 text-[18px]" data-id="element-232">
          <X className="w-6 h-6 text-red-500 mr-2" data-id="element-233" /> Lo que pasa sin
          REFLEXO-PRO:
        </h3>
        <ul className="space-y-4" data-id="element-234">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-235">
              <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 shrink-0" data-id="element-236" />
              <span className="text-brand-text/80 text-[12px]" data-id="element-237">{point}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-238">
        <h3 className="md:text-3xl font-serif font-bold rose-gradient-text text-[22px]" data-id="element-239">
          ¿Y si esta fuera la última semana que trabajás así?
        </h3>
      </div>
    </Section>;
};